import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../api/client';

const initialState = {
    items: [],
    status: 'idle',
    error: null
};

export const fetchLatestNews = createAsyncThunk('news/fetchLatestNews', async () => {
    const response = await client.get('/get_news');
    return response;
});




const newsSlice = createSlice({
    name: 'news',
    initialState,
    reducers: {
    },
    extraReducers: {
        [fetchLatestNews.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchLatestNews.fulfilled]: (state, action) => {
            state.status = 'succeeded';

            state.items = action.payload;
        },
        [fetchLatestNews.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        }
    }
});



export default newsSlice.reducer;

export const selectLatestNews = (state) => state.news.items;

